export default {
  status: state => state.status,
  loading: state => state.loading,
  error: state => state.error,
  message: state => state.error && state.error.data.message,
  dashboard: state => state.dashboard,
}
